"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _lodash = _interopRequireDefault(require("lodash.intersection"));

var _Asset = _interopRequireDefault(require("../../Asset"));

var _SourceTags = _interopRequireDefault(require("./SourceTags"));

var _SourceSearch = _interopRequireDefault(require("./SourceSearch"));

var _AssetsLoader = _interopRequireDefault(require("./AssetsLoader"));

var _searchableResourceTypes = _interopRequireDefault(require("../constants/searchableResourceTypes"));

require("../styles/_source-assets-modal.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SourceAssetsInlineModal = /*#__PURE__*/function (_Component) {
  _inherits(SourceAssetsInlineModal, _Component);

  var _super = _createSuper(SourceAssetsInlineModal);

  function SourceAssetsInlineModal(props) {
    var _this;

    _classCallCheck(this, SourceAssetsInlineModal);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "fetchAllAssetIds", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props, getAllAssets, project, addAssetsToMap, _yield$getAllAssets, data, error, allAssets;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, getAllAssets = _this$props.getAllAssets, project = _this$props.project, addAssetsToMap = _this$props.addAssetsToMap;
              _context.next = 3;
              return getAllAssets({
                organisationId: project.organisationId
              });

            case 3:
              _yield$getAllAssets = _context.sent;
              data = _yield$getAllAssets.data;
              error = _yield$getAllAssets.error;

              if (!(!data || !data.getAssets || error)) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return");

            case 8:
              allAssets = data.getAssets;
              addAssetsToMap(allAssets);

              _this.setState({
                allAssetIds: allAssets.map(function (_ref2) {
                  var assetId = _ref2.assetId;
                  return assetId;
                })
              });

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "onDeleteTag", function (index) {
      var tags = _this.state.tags;
      var _this$props2 = _this.props,
          sourcedAssets = _this$props2.sourcedAssets,
          updateSourcedAssets = _this$props2.updateSourcedAssets;

      var newTags = _toConsumableArray(tags);

      newTags.splice(index, 1);
      var newAssetIds = _this.aggregateAndFetchAssetIds(newTags) || []; // If there's no more tags we show all assets, so the existing selections are still valid

      var newSelected = newTags.length ? sourcedAssets.filter(function (assetId) {
        return newAssetIds.includes(assetId);
      }) : sourcedAssets;
      updateSourcedAssets(newSelected);

      _this.setState({
        tags: newTags,
        visibleAssetIds: newAssetIds
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSelectSource", function (source) {
      var tags = _this.state.tags;

      if (tags.some(function (tag) {
        return tag.id === source.id;
      })) {
        return;
      }

      var newTags = [].concat(_toConsumableArray(tags), [source]);

      _this.setState({
        tags: newTags,
        visibleAssetIds: _this.aggregateAndFetchAssetIds(newTags)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSelectAsset", function (assetId) {
      return function () {
        var _this$props3 = _this.props,
            sourcedAssets = _this$props3.sourcedAssets,
            updateSourcedAssets = _this$props3.updateSourcedAssets;
        var isSelected = sourcedAssets.includes(assetId);

        if (!isSelected) {
          return void updateSourcedAssets([].concat(_toConsumableArray(sourcedAssets), [assetId]));
        }

        var newSelected = _toConsumableArray(sourcedAssets);

        var index = newSelected.findIndex(function (id) {
          return assetId === id;
        });
        newSelected.splice(index, 1);
        updateSourcedAssets(newSelected);
      };
    });

    _defineProperty(_assertThisInitialized(_this), "viewAssetDetails", function (assetId) {
      return function () {
        _this.setState({
          assetDetailsId: assetId
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this), "closeDetailsModal", function () {
      _this.setState({
        assetDetailsId: void 0
      });
    });

    var _project = props.project;
    _this.state = {
      tags: [{
        displayName: _project.name,
        type: _searchableResourceTypes.default.PROJECT,
        id: _project.videoProjectId,
        assetIds: _project.assetIds
      }],
      visibleAssetIds: _project.assetIds
    };
    return _this;
  }

  _createClass(SourceAssetsInlineModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchAllAssetIds();
    }
  }, {
    key: "aggregateAndFetchAssetIds",
    value: function aggregateAndFetchAssetIds(sources) {
      var allAssetIds = this.state.allAssetIds;

      if (!sources.length) {
        return allAssetIds;
      }

      return _lodash.default.apply(void 0, _toConsumableArray(sources.map(function (source) {
        return source.assetIds;
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          onClose = _this$props4.onClose,
          project = _this$props4.project,
          sourcedAssets = _this$props4.sourcedAssets,
          apolloClient = _this$props4.apolloClient,
          canUpdateVideo = _this$props4.canUpdateVideo;
      var _this$state = this.state,
          tags = _this$state.tags,
          visibleAssetIds = _this$state.visibleAssetIds,
          allAssetIds = _this$state.allAssetIds,
          assetDetailsId = _this$state.assetDetailsId;
      return (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_commonReact.ManageAssetModal, {
          assetId: assetDetailsId,
          apiClient: apolloClient,
          isVisible: Boolean(assetDetailsId),
          onClose: this.closeDetailsModal
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "source-assets-modal"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "source-assets-modal__header"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "asset-selection-header__left"
        }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
          name: "medialibrary",
          size: 20,
          color: "russian"
        }), /*#__PURE__*/_react.default.createElement("p", null, "Source from Shootsta DAM")), /*#__PURE__*/_react.default.createElement(_uiKit.ActionButton, {
          icon: "close",
          labelText: "CLOSE",
          iconSize: 15,
          onClick: onClose
        })), /*#__PURE__*/_react.default.createElement(_SourceSearch.default, {
          onSelectSource: this.onSelectSource,
          organisationId: project.organisationId
        }), /*#__PURE__*/_react.default.createElement(_SourceTags.default, {
          tags: tags,
          onDeleteTag: this.onDeleteTag
        }), /*#__PURE__*/_react.default.createElement("p", null, "Showing", /*#__PURE__*/_react.default.createElement("span", {
          className: "source-assets-modal__asset-quantity"
        }, " ".concat(visibleAssetIds ? visibleAssetIds.length : 0, " ").concat(allAssetIds ? " of ".concat(allAssetIds.length) : '', " ")), "assets"), !visibleAssetIds ? /*#__PURE__*/_react.default.createElement("div", {
          className: "source-assets-modal__no-assets"
        }, /*#__PURE__*/_react.default.createElement(_AssetsLoader.default, null)) : null, visibleAssetIds && !visibleAssetIds.length ? /*#__PURE__*/_react.default.createElement("div", {
          className: "source-assets-modal__no-assets"
        }, /*#__PURE__*/_react.default.createElement("p", null, 'There aren\'t any matching assets for these filters.')) : null, visibleAssetIds && visibleAssetIds.length ? /*#__PURE__*/_react.default.createElement("div", {
          className: "source-assets-modal__asset-container"
        }, visibleAssetIds && visibleAssetIds.map(function (assetId) {
          return (/*#__PURE__*/_react.default.createElement(_Asset.default, {
              key: assetId,
              onChange: _this2.onSelectAsset(assetId),
              assetId: assetId,
              selected: sourcedAssets.includes(assetId),
              selectedForVideo: false,
              viewAssetDetails: _this2.viewAssetDetails(assetId),
              canUpdateVideo: canUpdateVideo,
              inverseColours: true
            })
          );
        })) : null))
      );
    }
  }]);

  return SourceAssetsInlineModal;
}(_react.Component);

exports.default = SourceAssetsInlineModal;